import { removeStylesFromEditorV3 } from "@azu-business/editor-v3";
import { AioReplacement } from "aic";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";

/**
 * Recursively remove Optional and Notes styles from a nested array of
 * replacement sublists. Returns undefined when no sublists are provided.
 *
 * @param subLists - Optional array of nested replacement sublists
 * @returns Processed sublists with styles removed, or undefined if no sublists
 */
export const removeStylesFromSubLists = <T>(
  subLists?: AioReplacement<T>[],
): AioReplacement<T>[] | undefined => {
  if (!subLists) return undefined;

  return subLists.map((subList) => ({
    ...subList,
    newTexts: subList.newTexts.map((newText) => ({
      ...newText,
      texts: newText.texts.map((text) =>
        removeStylesFromEditorV3(text, STYLES_TO_DELETE, STYLES_TO_CLEAN),
      ),
      subLists: removeStylesFromSubLists(newText.subLists),
    })),
  }));
};
